import styles from "./cancel_confirmation.module.scss"

interface Props {
  expirationDate: string
  exploreUrl: string
  tierName: string
}

const CancelConfirmation = ({ expirationDate, exploreUrl, tierName }: Props) => {
  return (
    <div className={styles.cancel_confirmation}>
      <h1 className="mb2--phone mb2--small-phone">Plan cancelled</h1>

      {/* Wrapper keeps the ps out of the legacy `section > div > p` 550px clamp
          that the welcome-back promotion still relies on. */}
      <div className={styles.description}>
        <p>
          Your IFTTT {tierName} subscription will end on {expirationDate}.
        </p>
        <p>At that time your benefits will end and your card will not be charged.</p>
      </div>

      <div className={styles.ctas}>
        <a className="button-secondary" href={exploreUrl}>
          Return to home
        </a>
      </div>
    </div>
  )
}

export default CancelConfirmation
